import React, { FC, useCallback, useMemo, useState } from 'react';
import { Button, Form, Modal, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import AddOrEditContractorClientModal from './AddOrEditContractorClientModal';

const FORM_NAME = 'contractor-ow-form';

const AddContractorClientModal: FC<any> = ({
	onCancel,
	targetCollectionName,
}): React.ReactElement => {
	const [form] = useForm();

	const [modalVisible, setModalVisible] = useState(false);
	const [current, setCurrent] = useState(0);
	const isOW = Form.useWatch('isOW', form) === 'true';

	const steps = useMemo(
		() => [
			{
				title: 'Step 1',
				fields: ['isOW'],
				content: (
					<Form.Item
						name="isOW"
						rules={[
							{
								required: true,
								message: 'Please select a valid option.',
							},
						]}
						label="Is your client, using OpenWrench already?"
					>
						<OWRadioGroup
							valueAccessor={(item) => item.value}
							renderRecord={(item) => item.label}
							items={[
								{
									label: 'Yes',
									value: 'true',
								},
								{
									label: 'No',
									value: 'false',
								},
							]}
						/>
					</Form.Item>
				),
			},
			{
				title: 'Step 1',
				fields: [''],
				end: true,
				content: <div className="pb-4">Please ask your client to add you in their network</div>,
			},
		],
		[]
	);

	const next = useCallback(async () => {
		try {
			await form.validateFields(steps[current].fields);
			if (isOW) {
				setCurrent(current + 1);
			} else {
				setModalVisible(true);
			}
		} catch (error) {
			console.log('Validation failed:', error);
		}
	}, [current, form, isOW, steps]);

	const prev = () => setCurrent(current - 1);

	return (
		<>
			<Modal
				visible={!modalVisible}
				width={600}
				title="New Client"
				onCancel={onCancel}
				closable
				footer={null}
			>
				<Form requiredMark={false} id={FORM_NAME} layout="vertical" form={form}>
					{steps.map((step, index) => (
						<div key={index} style={{ display: current === index ? 'block' : 'none' }}>
							{step.content}
						</div>
					))}
					<Row
						justify="end"
						style={{
							borderTop: 'solid 1px rgba(0, 0, 0, 0.1)',
							paddingTop: '8px',
							margin: '0 0 -8px',
						}}
					>
						{current > 0 && (
							<Button onClick={prev} style={{ marginRight: 8 }}>
								Previous
							</Button>
						)}
						{current < steps.length - 1 && (
							<Button type="primary" onClick={next}>
								Next
							</Button>
						)}
						{current === steps.length - 1 && (
							<Button type="primary" onClick={onCancel}>
								Okay
							</Button>
						)}
					</Row>
				</Form>
			</Modal>
			{modalVisible ? (
				<AddOrEditContractorClientModal
					onCancel={onCancel}
					targetCollectionName={targetCollectionName}
				/>
			) : null}
		</>
	);
};

export default AddContractorClientModal;
